import { render, staticRenderFns } from "./BotaoDownloadComLabel.vue?vue&type=template&id=07ce0634&scoped=true"
import script from "./BotaoDownloadComLabel.vue?vue&type=script&lang=js"
export * from "./BotaoDownloadComLabel.vue?vue&type=script&lang=js"
import style0 from "./BotaoDownloadComLabel.vue?vue&type=style&index=0&id=07ce0634&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ce0634",
  null
  
)

export default component.exports